import { render, staticRenderFns } from "./ProjectViewXList.vue?vue&type=template&id=059c643e&scoped=true&"
import script from "./ProjectViewXList.vue?vue&type=script&lang=ts&"
export * from "./ProjectViewXList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectViewXList.vue?vue&type=style&index=0&id=059c643e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059c643e",
  null
  
)

export default component.exports